import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent  implements OnInit {
  @Input() title: string = '';
  @Input() message: string = ''; // raw HTML
  @Input() okText: string = 'OK';

  safeMessage: SafeHtml = '';

  constructor(
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    // sanitize HTML before rendering
    this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
  }

  dismiss() {
    this.modalCtrl.dismiss(true);
  }

}
